import { FeatureFlag } from '@app/enums';
import { ProfileTabs } from '../enums/profile-tabs.enum';
import { TranslatableKey } from '@app/types/translatable.type';

export enum Levels {
    edit = 'edit',
    view = 'view',
}

export enum EmployeeAccessLevels {
    all = 'settings.role-permissions.accessLevels.allEmployees',
    directReports = 'settings.role-permissions.accessLevels.directReports',
    reports = 'settings.role-permissions.accessLevels.directAndIndirectReports',
    onlySelf = 'settings.role-permissions.accessLevels.onlySelf',
}

export interface ProfileSegment {
    label: TranslatableKey;
    level: Levels | null;
    view: string[];
    edit: string[];
    nest?: boolean;
    showIfHasFeatureFlag?: FeatureFlag;
    hideIfHasFeatureFlag?: FeatureFlag;
}

export interface Profile {
    tab: ProfileTabs;
    title: TranslatableKey;
    segments?: ProfileSegment[];
    showIfHasFeatureFlag?: FeatureFlag;
    hideIfHasFeatureFlag?: FeatureFlag;
}
